import Vue from 'vue';
import Vuex from 'vuex';
import act from '../actions/competition';
import mut from '../mutations/competition';
import glMut from '../mutations/global';

Vue.use(Vuex);

const store = {
    state: {
        competitions: null,
        selectedCompetition: null,
        cId: JSON.parse(localStorage.getItem('cId')),
        pw: JSON.parse(localStorage.getItem('pw')),
        isCompetitionLoading: false,
    },
    mutations: {
        [mut.SETCOMPETITIONS]: (state, competitions) => {
            state.competitions = competitions;
            state.isCompetitionLoading = false;
        },
        [mut.SETSELECTEDCOMPETITION]: (state, competition) => {
            localStorage.setItem('cId', JSON.stringify(competition.id));
            state.cId = competition.id;
            state.selectedCompetition = competition;
        },
        [glMut.LOGOUT]: (state) => {
            state.selectedCompetition = null;
            state.pw = null;
            state.cId = null;
            localStorage.removeItem('cId');
            localStorage.removeItem('pw');
        },
    },
    actions: {
        [act.GETCOMPETITIONS]: ({ state, rootGetters }) => {
            try {
                state.isCompetitionLoading = true;
                rootGetters.Connection.invoke("RequestCompetitionList").catch(function (err) {
                    state.isCompetitionLoading = false;
                    return console.error(err.toString());
                });
            }
            catch (error) {
                console.error(error);
            }
        },        
    },
    getters: {
        Competitions: state => state.competitions,
        SelectedCompetition: state => state.selectedCompetition,
        CId: state => state.cId,
        Pw: state => state.pw,
        IsCompetitionLoading: state => state.isCompetitionLoading,
    }

};

export default store;